module.exports = __webpack_public_path__ + "static/media/home6.bce934d4.png";